// A user can have different Mail and UPN (userPrincipalName) in Entra ID.
// Event owners are stored by Mail (owner picker), while the login account / API token uses UPN,
// so owner checks must accept any of the user's addresses.

export function getUserEmails(profile?: any, account?: any): string[] {
    const candidates = [
        profile?.mail,
        profile?.userPrincipalName,
        account?.username,
        account?.idTokenClaims?.email,
        account?.idTokenClaims?.preferred_username,
    ];
    return Array.from(new Set(
        candidates
            .filter((e): e is string => typeof e === 'string' && e.includes('@'))
            .map(e => e.trim().toLowerCase())
    ));
}

export function isOwnerOf(ownerString: string | null | undefined, userEmails: string[]): boolean {
    if (!ownerString || userEmails.length === 0) return false;
    return ownerString
        .split(/[;,]/)
        .map(o => o.trim().toLowerCase())
        .filter(Boolean)
        .some(o => userEmails.includes(o));
}
